import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';
import * as yup from 'yup';

const config = {
    name: 'shops',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'create' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' },
        { type: 'request', name: 'getEmployees' },
        { type: 'request', name: 'addEmployee' },
        { type: 'request', name: 'updateEmployee' },
        { type: 'request', name: 'removeEmployee' }
    ],
    endpoints: {
        shops: '/shops',
        shop: '/shops/[id]',
        employees: '/shops/[id]/employees',
        employee: '/shop-employees/[employeeId]'
    },
    defaults: {
        createShop: {
            name: '',
            address: '',
            phone: '',
            email: '',
            operatingHours: {
                monday: { open: '09:00', close: '21:00', closed: false },
                tuesday: { open: '09:00', close: '21:00', closed: false },
                wednesday: { open: '09:00', close: '21:00', closed: false },
                thursday: { open: '09:00', close: '21:00', closed: false },
                friday: { open: '09:00', close: '21:00', closed: false },
                saturday: { open: '10:00', close: '20:00', closed: false },
                sunday: { open: '10:00', close: '18:00', closed: false }
            },
            minStaffPerShift: 2,
            color: '#3174ad',
            active: true,
            timezone: 'Europe/Bucharest'
        },
        addEmployee: {
            userId: null,
            contractHoursPerWeek: 40,
            hourlyRate: null,
            color: '#4CAF50'
        }
    },
    validations: {
        shop: yup.object().shape({
            name: yup.string().required("Numele este obligatoriu"),
            minStaffPerShift: yup.number().min(1, "Minim 1 persoană").required("Numărul minim de angajați este obligatoriu"),
            email: yup.string().email("Email invalid").nullable()
        }),
        employee: yup.object().shape({
            userId: yup.number().required("Selectați un utilizator"),
            contractHoursPerWeek: yup.number().min(1).max(168).required("Orele contractuale sunt obligatorii")
        })
    }
}

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
